<template>
    <inertia-link :href="'/'" class="mx-auto">
        <img :src="$page.props.logo_mark" class="w-16 mx-auto">
    </inertia-link>
</template>
